"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionFilterType = exports.DEFAULT_FILTER_JAQL_WRAPPER = exports.DEFAULT_FILTER_JAQL_BY_TYPE_MAP = exports.FILTER_TYPES = exports.nonSupportedMinutesBuckets = exports.FilterModalType = exports.DatetimeLevel = exports.NumericFilterType = exports.DateTimeFilterType = exports.GeneralFilterType = void 0;
var GeneralFilterType;
(function (GeneralFilterType) {
    GeneralFilterType["INCLUDE_ALL"] = "INCLUDE_ALL";
    GeneralFilterType["ADVANCED"] = "ADVANCED";
    GeneralFilterType["INVALID"] = "INVALID";
    GeneralFilterType["CONDITION"] = "CONDITION";
    GeneralFilterType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
})(GeneralFilterType = exports.GeneralFilterType || (exports.GeneralFilterType = {}));
var DateTimeFilterType;
(function (DateTimeFilterType) {
    DateTimeFilterType["PERIOD"] = "PERIOD";
    DateTimeFilterType["DATE_RANGE"] = "DATE_RANGE";
})(DateTimeFilterType = exports.DateTimeFilterType || (exports.DateTimeFilterType = {}));
var NumericFilterType;
(function (NumericFilterType) {
    NumericFilterType["NUMERIC_RANGE"] = "NUMERIC_RANGE";
})(NumericFilterType = exports.NumericFilterType || (exports.NumericFilterType = {}));
var DatetimeLevel;
(function (DatetimeLevel) {
    DatetimeLevel["YEARS"] = "years";
    DatetimeLevel["QUARTERS"] = "quarters";
    DatetimeLevel["MONTHS"] = "months";
    DatetimeLevel["WEEKS"] = "weeks";
    DatetimeLevel["DAYS"] = "days";
    DatetimeLevel["HOURS"] = "hours";
    DatetimeLevel["MINUTES"] = "minutes";
})(DatetimeLevel = exports.DatetimeLevel || (exports.DatetimeLevel = {}));
var FilterModalType;
(function (FilterModalType) {
    FilterModalType["DATE_TIME"] = "datetime";
    FilterModalType["NUMERIC"] = "numeric";
    FilterModalType["TEXT"] = "text";
})(FilterModalType = exports.FilterModalType || (exports.FilterModalType = {}));
exports.nonSupportedMinutesBuckets = ['1', '30'];
exports.FILTER_TYPES = Object.assign(Object.assign(Object.assign({}, GeneralFilterType), DateTimeFilterType), NumericFilterType);
exports.DEFAULT_FILTER_JAQL_BY_TYPE_MAP = {
    [exports.FILTER_TYPES.INCLUDE_ALL]: {
        all: true,
        filterType: exports.FILTER_TYPES.INCLUDE_ALL,
    },
    [exports.FILTER_TYPES.PERIOD]: {
        last: { count: 1, offset: 1 },
        isNotCurrentPeriod: true,
        filterType: exports.FILTER_TYPES.PERIOD,
    },
    [exports.FILTER_TYPES.DATE_RANGE]: {
        filterType: exports.FILTER_TYPES.DATE_RANGE,
    },
    [exports.FILTER_TYPES.NUMERIC_RANGE]: {
        filterType: exports.FILTER_TYPES.NUMERIC_RANGE,
    },
    [exports.FILTER_TYPES.CONDITION]: {
        explicit: false,
        multiSelection: true,
        exclude: { members: [] },
        filterType: exports.FILTER_TYPES.CONDITION,
    },
    [exports.FILTER_TYPES.SPECIFIC_ITEMS]: {
        explicit: true,
        multiSelection: true,
        members: [],
        filterType: exports.FILTER_TYPES.SPECIFIC_ITEMS,
    },
};
exports.DEFAULT_FILTER_JAQL_WRAPPER = {
    filter: exports.DEFAULT_FILTER_JAQL_BY_TYPE_MAP.INCLUDE_ALL,
    level: DatetimeLevel.YEARS,
};
var ConditionFilterType;
(function (ConditionFilterType) {
    ConditionFilterType["IS"] = "members";
    ConditionFilterType["IS_NOT"] = "exclude";
    ConditionFilterType["IS_WITHIN"] = "isWithin";
    ConditionFilterType["TOP"] = "top";
    ConditionFilterType["BOTTOM"] = "bottom";
    ConditionFilterType["AFTER"] = "after";
    ConditionFilterType["BEFORE"] = "before";
    ConditionFilterType["STARTS_WITH"] = "startsWith";
    ConditionFilterType["DOESNT_START_WITH"] = "doesntStartWith";
    ConditionFilterType["ENDS_WITH"] = "endsWith";
    ConditionFilterType["DOESNT_END_WITH"] = "doesntEndWith";
    ConditionFilterType["CONTAINS"] = "contains";
    ConditionFilterType["DOESNT_CONTAIN"] = "doesntContain";
    ConditionFilterType["EQUALS"] = "equals";
    ConditionFilterType["DOESNT_EQUAL"] = "doesntEqual";
    ConditionFilterType["IS_EMPTY"] = "isEmpty";
    ConditionFilterType["IS_NOT_EMPTY"] = "isNotEmpty";
    ConditionFilterType["GREATER_THAN"] = "fromNotEqual";
    ConditionFilterType["GREATER_THAN_OR_EQUAL"] = "from";
    ConditionFilterType["LESS_THAN"] = "toNotEqual";
    ConditionFilterType["LESS_THAN_OR_EQUAL"] = "to";
    ConditionFilterType["BETWEEN"] = "between";
    ConditionFilterType["IS_NOT_BETWEEN"] = "isNotBetween";
    ConditionFilterType["MULTIPLE_CONDITION"] = "multipleCondition";
    ConditionFilterType["NONE"] = "none";
})(ConditionFilterType = exports.ConditionFilterType || (exports.ConditionFilterType = {}));
